import { request } from "../utils/request.js"

export const department_addNew = (pojo, args) => request({
    url: 'department/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const department_update = (pojo, args) => request({
    url: 'department/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const department_findByPageForManage = (pojo, args) => request({
    url: 'department/findByPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const department_findListForManage = (pojo, args) => request({
    url: 'department/findListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const department_changeFrozenStatus = (id, args) => request({
    url: 'department/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const department_deleteById = (id, args) => request({
    url: 'department/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const department_findById = (id, args) => request({
    url: 'department/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/department.js